import axios from "axios";
import { API, getDeviceId } from "@/lib/api";

const base = () => `${API}/family/${getDeviceId()}/golden-acorns`;
const pinHeader = (pin) => ({ headers: { "X-Parent-Pin": pin } });
const changed = (d) => { window.dispatchEvent(new Event("pp-golden-changed")); return d; };

export const SOURCE_LABEL = { app: "NICE app", siri: "Siri", alexa: "Alexa" };
export const getGolden = async (profileId) => (await axios.get(base(), { params: profileId ? { profile_id: profileId } : {} })).data;
export const getGoldenNew = async () => (await axios.get(`${base()}/new`)).data.new;
export const markGoldenSeen = async (pin) => changed((await axios.post(`${base()}/seen`, {}, pinHeader(pin))).data);
export const assignGolden = async (pin, id, profileId) =>
  changed((await axios.patch(`${base()}/${id}`, { profile_id: profileId || null }, pinHeader(pin))).data);
export const getVoiceKey = async () => (await axios.get(`${API}/family/${getDeviceId()}/voice-key`)).data.family_key;
export const getGoldenEmail = async () => (await axios.get(`${API}/account/golden-email`)).data.golden_email;
export const setGoldenEmail = async (on) => (await axios.put(`${API}/account/golden-email`, { golden_email: on })).data.golden_email;
